import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

// Loader Components
import showLoader from '@components/loader';

export const getRoad = createAsyncThunk('roadSlice/getRoad', async () => {
    try {
        let response = await axios.get('/road', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getRoadOption = createAsyncThunk('roadSlice/getRoadOption', async () => {
    try {
        showLoader(true);
        let response = await axios.get('/road?option=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createRoad = createAsyncThunk('roadSlice/createRoad', async (data, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.post('/road', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Road created successfully.');
        dispatch(getRoad());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateRoad = createAsyncThunk('roadSlice/updateRoad', async (data, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.put('/road/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Road speed rule updated successfully.');
        dispatch(getRoad());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const deleteRoad = createAsyncThunk('roadSlice/deleteRoad', async (deleteId, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.delete('/road/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Road speed rule deleted successfully');
        dispatch(getRoad());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateRoadStatus = createAsyncThunk('roadSlice/updateRoadStatus', async (id, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.put('/road/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status updated successfully.');
        dispatch(getRoad());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.err(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const roadSlice = createSlice({
    name: 'roadSlice',
    initialState: {
        data: [],
        option: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getRoad.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
        builder.addCase(getRoadOption.fulfilled, (state, action) => {
            state.option = action.payload;
            return;
        });
    }
});

export default roadSlice.reducer;
